/**
 * The fallback circle (D73): initials over the deterministic two-stop
 * gradient — the same hash, the same palette, the same circle the desktop
 * draws, because the math lives in `echo-wire` and arrives here through
 * wasm. A photo, when worn, lies OVER the initials (no fallback branch: a
 * broken image simply reveals them).
 */
import { type JSX, Show } from "solid-js";

import { avatarUrl } from "../lib/api/rest";
import { avatarGradient, avatarInitials } from "../lib/wasm";

export function AvatarCircle(props: {
  name: string;
  createdAt: number;
  size: 16 | 26 | 28 | 30 | 32 | 34 | 36 | 38 | 40 | 44 | 46 | 88 | 96;
  fileId?: string | null;
  absolute?: boolean;
}): JSX.Element {
  return (
    <span
      class={`avatar avatar--size-${props.size}${props.absolute ? " avatar--absolute" : ""}`}
      style={`background-image:${avatarGradient(props.name, props.createdAt)}`}
    >
      {avatarInitials(props.name)}
      <Show when={props.fileId}>
        {(id) => <img class="avatar__image" src={avatarUrl(id())} alt="" draggable={false} />}
      </Show>
    </span>
  );
}
